<template>
	<div>
  	<router-view></router-view>
		<message-handler></message-handler>
  </div>
</template>

<script>
	import MessageHandler from './components/helpers/MessageHandler.vue';
	import MenuSidebar from './components/menus/MenuSidebar.vue';

	export default {
		components: { MenuSidebar, MessageHandler },
	  data () {
	    return {
	      msg: ''
	    }
		}
	}
</script>

<style type="text/css">
	.shop_wrapper{ margin-top: 24px;  }
</style>
